import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typography, Button, Color } from '@figure/frontlib-gui';

export const ProductName = styled(Typography.BodyBold)`
  font-family: 'Poppins';
  font-size: 1.7rem;
  text-align: center;
`;

export const ProductAPR = styled(ProductName)`
  font-size: 3.5rem;
  line-height: 1.2;
  font-weight: 700;
`;

export const ProductButton = styled(Button)`
  border: 1px solid ${Color.PURPLE_RAIN};
  color: ${Color.PURPLE_RAIN};
`;

export const offerInfoType = PropTypes.shape({
  maxAmount: PropTypes.number,
  terms: PropTypes.arrayOf(PropTypes.number),
});
